import { styled } from '@mui/material/styles';

export const BodyContainer = styled('div')`
    margin: 120px 5px 0 5px;
`;
